/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/** Unique tabs using H6 as an anchor **/
document.addEventListener("DOMContentLoaded", function(event) { 
	//check if there are h6 headings in the product description
	//if true add 'accordion-group' element to the bottom of the product description
	if ($('.product-single__box__block--description').find('h6').length > 0) {
		$('.product-single__box__block--description').append('<accordion-group class="unique-tabs u-mt"></accordion-group>');
	}

	//iterate each h6 element in the product description
  $($('.product-single__box__block--description').find('h6').get().reverse()).each(function(i) {
    var tabName = $(this).text();
    tabContent = '';
    //check if h6 has text inside
    if ($(this).text() != '') {
        //hide h6
        $(this).hide();
          //combine content between H6 elements
          $(this).nextUntil('h6').each(function() {
            tabContent = tabContent + this.outerHTML;
            //hide content
            $(this).hide();
          });

          //add 'details' wrapping element with unique class
          $('accordion-group.unique-tabs').prepend('<details class="unique-tab-'+ [i] +'"></details>');

          //generate tab HTML
          $('details.unique-tab-'+ [i]).prepend('<details-content><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></details-content>');
          $('details.unique-tab-'+ [i]).prepend('<summary><h3 class="f-family--body u-large u-text-transform--none u-color-text u-mb0">' + tabName + '</h3><summary-icon><i class="icon icon--plus" aria-hidden="true"></i></summary-icon></summary>');

          new Accordion(document.querySelector('details.unique-tab-'+ [i]));
          
      } else {  
        //hide empty H6
        $(this).hide();
      }
  });
});
